import React from 'react';
import { hashHistory } from 'react-router';
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import { TablePagination } from '@mui/material';

export function DisplayClaims({ currencyCode, classes, claims, pagingData, getClaimsFiltered }) {
  var safeClaimsData = claims || [];
  var safePagingData = pagingData || { total: 0, page: 1, size: 10 };

  var claimsFormatted = safeClaimsData.map(function(claim) {
    var details = claim.claim_details || {};
    var additionalDetails = details.additional_details || {};
    var primaryBenefit = claim.benefits && claim.benefits.length > 0 ? claim.benefits[0] : null;

    return {
      ...claim,
      policy_number: details.policy_number || 'N/A',
      deceased_name: details.dependant_fullname || 'N/A',
      relationship: details.relationship_to_policyholder || 'N/A',
      cause_of_death: additionalDetails.cause_of_death || 'N/A',
      benefit_type: primaryBenefit ? primaryBenefit.type : 'N/A',
      cover_amount: primaryBenefit ? primaryBenefit.max_benefit_amount_in_cents : null,
    };
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} sm={12}>
        <TableInc
          columns={[
            {
              title: 'Claim Number',
              field: 'claim_number',
              render: function(rowData) { return rowData.claim_number || 'N/A'; }
            },
            {
              title: 'Policy Number',
              field: 'policy_number',
              render: function(rowData) { return rowData.policy_number || 'N/A'; }
            },
            {
              title: 'Deceased',
              field: 'deceased_name',
              render: function(rowData) { return rowData.deceased_name || 'N/A'; }
            },
            {
              title: 'Relationship',
              field: 'relationship',
              render: function(rowData) { return rowData.relationship || 'N/A'; }
            },
            {
              title: 'Cause of Death',
              field: 'cause_of_death',
              render: function(rowData) { return rowData.cause_of_death || 'N/A'; }
            },
            {
              title: 'Benefit Type',
              field: 'benefit_type',
              render: function(rowData) { return rowData.benefit_type || 'N/A'; }
            },
            {
              title: 'Cover Amount',
              field: 'cover_amount',
              render: function(rowData) {
                if (rowData.cover_amount === null || rowData.cover_amount === undefined) return 'N/A';
                return currencyCode + ' ' + (rowData.cover_amount / 100).toLocaleString();
              }
            },
            {
              title: 'Waiting Period',
              field: 'is_waiting_period',
              render: function(rowData) {
                if (rowData.is_waiting_period === true) return 'Yes';
                if (rowData.is_waiting_period === false) return 'No';
                return 'N/A';
              }
            },
            {
              title: 'Status',
              field: 'status',
              render: function(rowData) { return rowData.status || 'N/A'; }
            },
            {
              title: 'Created Date',
              field: 'created_at',
              render: function(rowData) { return formatDateLocale(rowData.created_at) || 'N/A'; }
            },
            {
              title: 'Created By',
              field: 'web_agent_name',
              render: function(rowData) { return rowData.web_agent_name || 'N/A'; }
            },
            {
              title: 'Action',
              field: 'claimaction',
              render: function(rowData) {
                return (
                  <div className={classes.claimactionbt}>
                    <ButtonInc
                      onClick={function() {
                        hashHistory.push('admin/claim-processing-v2/' + rowData.guid);
                      }}
                      variant="contained"
                    >
                      View Claim
                    </ButtonInc>
                  </div>
                );
              }
            },
          ]}
          data={claimsFormatted}
          options={{
            showTitle: false,
            pageSize: safePagingData.size || 10,
            paging: false,
            search: false,
          }}
          components={{
            Pagination: function() { return null; }
          }}
        />
        <TablePagination
          component="div"
          count={safePagingData.total || 0}
          page={(safePagingData.page || 1) - 1}
          rowsPerPage={safePagingData.size || 10}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          onPageChange={function(event, newPage) {
            getClaimsFiltered({ page: newPage + 1, size: safePagingData.size });
          }}
          onRowsPerPageChange={function(event) {
            var newSize = parseInt(event.target.value, 10);
            getClaimsFiltered({ page: 1, size: newSize });
          }}
        />
      </Grid>
    </Grid>
  );
}
